module.exports = __webpack_public_path__ + "static/logo-purple-26c5122b95c319e5a64e746664432d77.svg";